"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    image: function image(_ref2) {
      var dimension = _ref2.dimension;
      return {
        borderRadius: 5,
        marginBottom: spacing(2),
        minWidth: dimension,
        maxWidth: dimension
      };
    }
  };
});
/**
 * Marketplace skeleton view.
 *
 * @param {object} props
 * @param {number} [props.id]
 * @param {boolean|undefined} [props.isMobile=false]
 * @param {number|undefined} [props.mobileSize=155]
 * @param {number|undefined} [props.size=276]
 *
 * @returns {ReactElement}
 */

var MarketplaceProductSkeleton = function MarketplaceProductSkeleton(_ref3) {
  var id = _ref3.id,
      _ref3$isMobile = _ref3.isMobile,
      isMobile = _ref3$isMobile === void 0 ? false : _ref3$isMobile,
      _ref3$mobileSize = _ref3.mobileSize,
      mobileSize = _ref3$mobileSize === void 0 ? 155 : _ref3$mobileSize,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 276 : _ref3$size;
  var dimension = isMobile ? mobileSize : size;
  var classes = useStyles({
    dimension: dimension
  });
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    "data-testid": "MarketplaceProductSkeleton-".concat(id),
    width: [mobileSize, size],
    minWidth: [mobileSize, size],
    maxWidth: [mobileSize, size],
    display: "flex",
    position: "relative",
    flexDirection: "column",
    alignItems: "flex-start",
    textAlign: "left",
    mb: 4,
    mx: [1, 2],
    flex: "1 1 0"
  }, /*#__PURE__*/_react["default"].createElement(_material.Skeleton, {
    className: classes.image,
    variant: "rectangular",
    width: dimension,
    height: isMobile ? 146 : 220
  }), /*#__PURE__*/_react["default"].createElement(_material.Skeleton, {
    variant: "text",
    width: "75%",
    height: 26
  }), /*#__PURE__*/_react["default"].createElement(_material.Skeleton, {
    variant: "text",
    width: "50%",
    height: 20
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(MarketplaceProductSkeleton);

exports["default"] = _default;